import { useEffect, useState } from 'react';

// The account's "Compact chat" setting, read from the body class the settings
// action toggles live (body.chat_style_modern means standard).
function isCompact() {
	return typeof document !== 'undefined' && !document.body.classList.contains('chat_style_modern');
}

export default function useCompactChatStyle() {
	const [compact, setCompact] = useState(isCompact);
	useEffect(() => {
		const observer = new MutationObserver(() => setCompact(isCompact()));
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
		return () => observer.disconnect();
	}, []);
	return compact;
}
